import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import { HomeIcon, LayoutGridIcon, TagIcon, ClipboardListIcon, UserIcon, ShoppingBagIcon } from 'lucide-react';
import { haptics } from '../../lib/utils/haptics';
import { useStore } from '../../lib/store';
export function MobileFooterNav() {
  const navigate = useNavigate();
  const location = useLocation();
  const cartCount = useStore(state => state.cartCount());
  const navItems = [{
    icon: HomeIcon,
    label: 'Home',
    path: '/',
    color: 'text-gray-500',
    activeColor: 'text-[#1E2B55]'
  }, {
    icon: LayoutGridIcon,
    label: 'Categories',
    path: '/category/all',
    color: 'text-gray-500',
    activeColor: 'text-[#1E2B55]'
  }, {
    icon: TagIcon,
    label: 'Offers',
    path: '/offers',
    color: 'text-gray-500',
    activeColor: 'text-red-600',
    badge: 'HOT',
    badgeColor: 'bg-gradient-to-r from-red-500 to-orange-500',
    animated: true
  }, {
    icon: ClipboardListIcon,
    label: 'RX',
    path: '/prescription',
    color: 'text-gray-500',
    activeColor: 'text-[#1E2B55]',
    badge: 'NEW',
    badgeColor: 'bg-[#4ADE80]',
    animated: true
  }, {
    icon: UserIcon,
    label: 'Account',
    path: '/account',
    color: 'text-gray-500',
    activeColor: 'text-[#1E2B55]'
  }];
  const handleNavClick = (path: string) => {
    haptics.selection();
    navigate(path);
  };
  return <nav className="md:hidden fixed bottom-0 left-0 right-0 bg-white/95 backdrop-blur-md border-t border-gray-100 z-50 safe-area-bottom shadow-[0_-4px_20px_rgba(0,0,0,0.03)]" data-id="element-3107" data-mp="35hyfwh58vflx">
      <div className="grid grid-cols-5 h-[68px]" data-id="element-3108" data-mp="3f9b48yru3nn7">
        {navItems.map(item => {
        const isActive = location.pathname === item.path;
        const Icon = item.icon;
        const iconColor = isActive ? item.activeColor : 'text-gray-400';
        return <button key={item.path} onClick={() => handleNavClick(item.path)} className="flex flex-col items-center justify-center gap-1.5 relative" data-id="element-3109" data-mp="2lvtkyqh7x4c5">
              <motion.div whileTap={{
            scale: 0.9
          }} animate={isActive ? {
            scale: 1.1,
            y: -3
          } : {
            scale: 1,
            y: 0
          }} transition={{
            type: 'spring',
            stiffness: 400,
            damping: 17
          }} className="relative" data-id="element-3110" data-mp="2uvq3ead0l6yr">
                <Icon className={`w-[22px] h-[22px] transition-colors duration-300 ${iconColor}`} strokeWidth={isActive ? 2.5 : 1.8} data-id="element-3111" data-mp="1j9i1fuznmpbo" />
                {item.badge && <motion.span initial={{
              scale: 0.8,
              opacity: 0
            }} animate={{
              scale: [1, 1.15, 1],
              opacity: 1
            }} transition={{
              scale: {
                repeat: Infinity,
                duration: 1.5,
                ease: 'easeInOut'
              },
              opacity: {
                duration: 0.3
              }
            }} className={`absolute -top-2.5 -right-3 ${item.badgeColor} text-white text-[9px] font-black rounded-full px-1.5 py-0.5 shadow-sm ring-2 ring-white`} data-id="element-3112" data-mp="1gpldqj6a9rnm">
                    {item.badge}
                  </motion.span>}
              </motion.div>
              <span className={`text-[11px] transition-all duration-300 tracking-tight ${isActive ? 'font-bold ' + iconColor : 'font-medium text-gray-400'}`} data-id="element-3113" data-mp="a6n80igklu9t">
                {item.label}
              </span>
            </button>;
      })}
      </div>
      <style jsx data-id="element-3114" data-mp="1o89sxubbunyv">{`
        @keyframes pulse {
          0%,
          100% {
            opacity: 1;
          }
          50% {
            opacity: 0.7;
          }
        }
        .animate-pulse {
          animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
        }
      `}</style>
    </nav>;
}